import React, { useEffect } from "react";
import { Layout, Affix } from "antd";
import { TxnDate } from "components";
import { App } from "context/AppContext";
import NavBar from "./navbar";
import SiderMenu from "./sidebar";
import Content from "./content";
import { isMobile } from "react-device-detect";

const { Sider } = Layout;

function AppLayout() {
  const { collapsed, toggleCollapsed, getUserData, getMenu, getTxnDate, getPaDicts } = App();

  useEffect(() => {
    getUserData();
    getMenu();
    getTxnDate();
    getPaDicts();

    if (isMobile) {
      toggleCollapsed(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Layout style={{ minHeight: "100vh" }}>
        <Affix offsetTop={0}>
          <Sider
            collapsible
            collapsed={collapsed}
            onCollapse={(val) => {
              toggleCollapsed(val);
            }}
            width={260}
          >
            <NavBar />
            <SiderMenu />
            <TxnDate />
          </Sider>
        </Affix>
        <Layout>
          <Content />
          {/* <AppFooter /> */}
        </Layout>
      </Layout>
    </div>
  );
}

export default AppLayout;
